import gql from "graphql-tag";

export default gql`
  query GetCompanyRequests($id: ID!) {
    allRequests(filter: { customer: { company: { id: $id } } }) {
      id
      createdAt
      title
      description
      priority
      status
      customer {
        id
        name
        email
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyRequests.ts